/* eslint-disable lyrahealth/no-react-native-text */
import React from 'react'

import { StyleSheet, Text, View } from '@react-pdf/renderer'

import { lightThemeColors } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/theme/colors'
import { Assignment } from '@lyrahealth-inc/shared-app-logic/src/models/assignments/Assignments'
import { Prescription } from '@lyrahealth-inc/shared-app-logic/src/models/prescription/Prescription'

import ItemListPDF from './ItemListPDF'

type MedicationsPDFProps = {
  medications: Prescription[]
  clientIntake?: Assignment
  isPrescriber?: boolean
}

const styles = StyleSheet.create({
  container: {
    marginTop: 24,
  },
  sectionTitle: {
    fontWeight: 'bold',
    fontSize: 18,
    color: lightThemeColors.textActive,
    borderBottomWidth: 1,
    borderBottomColor: lightThemeColors.textActive,
    marginBottom: 20,
    paddingBottom: 5,
  },
  emptyMessage: {
    fontSize: 12,
    color: lightThemeColors.textSecondary,
    textAlign: 'center',
    marginTop: 12,
    padding: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: lightThemeColors.borderDefault,
  },
  noIntakeContainer: {
    padding: 16,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: lightThemeColors.borderDefault,
    backgroundColor: lightThemeColors.backgroundPrimary,
  },
  noIntakeTitle: {
    fontSize: 16,
    color: lightThemeColors.textPrimary,
    marginBottom: 8,
    flexWrap: 'wrap',
    textAlign: 'center',
  },
  noIntakeDescription: {
    fontSize: 12,
    color: lightThemeColors.textSecondary,
    lineHeight: 1.4,
    flexWrap: 'wrap',
    textAlign: 'center',
  },
})

const MedicationsPDF: React.FC<MedicationsPDFProps> = ({ medications, clientIntake, isPrescriber }) => {
  if (!clientIntake) {
    return (
      <View style={styles.container}>
        <Text style={styles.sectionTitle}>Lyra Medications</Text>
        <View style={styles.noIntakeContainer}>
          <Text style={styles.noIntakeTitle}>Intake form incomplete</Text>
          <Text style={styles.noIntakeDescription}>
            Your client has not completed their client intake yet and therefore has not given consent.{' '}
            {isPrescriber &&
              'Encourage your client to complete this, as you will not be able to prescribe medication until they do so.'}
          </Text>
        </View>
      </View>
    )
  }

  if (!medications || medications.length === 0) {
    return (
      <View style={styles.container}>
        <Text style={styles.sectionTitle}>Lyra Medications</Text>
        <Text style={styles.emptyMessage}>This client does not have any medications</Text>
      </View>
    )
  }

  const medicationItems = medications.map((medication) => ({
    title: medication.DisplayName,
  }))

  return (
    <View style={styles.container}>
      <Text style={styles.sectionTitle}>Lyra Medications</Text>
      <ItemListPDF items={medicationItems} />
    </View>
  )
}

export default MedicationsPDF
